// extracted by mini-css-extract-plugin
export default {"container":"ProgressDots_container__QMQj2","item":"ProgressDots_item__bKqom","active":"ProgressDots_active__Y1Vjh"};